import { render, staticRenderFns } from "./channelBalance.vue?vue&type=template&id=7854333a&"
import script from "./channelBalance.vue?vue&type=script&lang=js&"
export * from "./channelBalance.vue?vue&type=script&lang=js&"
import style0 from "./channelBalance.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports